import React, { useState } from 'react';

import { IProductData } from 'src/environments/Checkout/interfaces';

import {
  ArrowUpIcon,
  CartIcon,
  ContainerResume,
  ContainerTotal,
  ContainerValues,
  ExpandResumePurchase,
  GrayLine,
  ImageCourse,
  PurchaseCheckout,
} from './style';

import arrowUpIconSVG from '../../../../../../assets/images/subscripiton-checkout-icons/arrow-up-icon.svg';
import cartIconSVG from '../../../../../../assets/images/subscripiton-checkout-icons/cart-icon.svg';

type Props = {
  productData: IProductData;
};

export default function PurchaseResume({ productData }: Props): JSX.Element {
  const [expandResume, setExpandResume] = useState(true);

  return (
    <ContainerResume>
      <ExpandResumePurchase
        onClick={() => {
          setExpandResume(!expandResume);
        }}
      >
        <CartIcon src={cartIconSVG} alt="Ícone de carrinho de compras" />
        <p>{expandResume ? 'Ocultar resumo da compra' : 'Exibir resumo da compra'}</p>
        <ArrowUpIcon
          src={arrowUpIconSVG}
          alt="Ícone de seta para cima, indicando ocultar o resumo da compra"
          transform={expandResume ? '' : 'scaleY(-1)'}
        />
      </ExpandResumePurchase>
      <PurchaseCheckout>
        {expandResume && <ImageCourse backImage={productData.productImage} />}
        {expandResume && <GrayLine />}
        <ContainerTotal>
          <h4>Total</h4>
          <ContainerValues>
            {productData.originalPrice !== productData.price && (
              <span>
                {(productData.originalPrice / 100).toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </span>
            )}
            <p>
              {(productData.price / 100).toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL',
              })}
            </p>
          </ContainerValues>
        </ContainerTotal>
      </PurchaseCheckout>
      <GrayLine />
    </ContainerResume>
  );
}
